import HttpService, { BaseResponse } from "../base";
// Types
import {
  setBalanceByUserIdRequest,
  setBalanceByUserIdResponse,
  setBuyingPowersByUserIdRequest,
  setBuyingPowersByUserIdResponse,
} from "src/VirtualOMS/types/user";

class UserProvider extends HttpService {
  constructor() {
    super({ suffix: "User" });
  }

  public addUser(data: string): BaseResponse<any> {
    return this.httpService.post("Add", data);
  }

  public getUser({
    userId,
    userName,
  }: {
    userId: number;
    userName: string;
  }): BaseResponse<any> {
    return this.httpService.get("Get", {
      params: {
        userId,
        userName,
      },
    });
  }

  /**
   * Dropdown Accont
   *
   * @async
   * @version 1.0.0
   */
  public getDropdown(): BaseResponse<any> {
    return this.httpService.get("GetDropDown");
  }

  /**
   * Add Remaining Balance button
   *
   * @param {setBalanceByUserIdRequest} data
   * @async
   * @version 1.0.0
   */
  public setBalanceByUserId(
    data: setBalanceByUserIdRequest
  ): BaseResponse<setBalanceByUserIdResponse> {
    return this.httpService.put("SetBalanceWithUserId", data);
  }

  public setBuyingPowersByUserId(
    data: setBuyingPowersByUserIdRequest
  ): BaseResponse<setBuyingPowersByUserIdResponse> {
    return this.httpService.put("SetBuyingPowersWithUserId", data);
  }

  public checkUserConnection(): BaseResponse<any> {
    return this.httpService.get("CheckConnection");
  }
}

const UserService = new UserProvider();

export default UserService;
